module.exports = __webpack_public_path__ + "static/media/scroll4_phone2_3x.56d8dfb5.png";